(function(){
  var r=document.getElementById('bcm1');
  if(!r) return;
  var FREE=3990;
  function eur(c){return (c/100).toLocaleString('de-DE',{minimumFractionDigits:2,maximumFractionDigits:2})+'\u00A0\u20AC';}
  function rate(n){ return n>=3?10:0; }
  function ship(net){
    return net>=FREE
      ? '<span class="vf">versandkostenfrei</span>'
      : 'zzgl. 4,90\u00A0\u20AC Versand \u2013 noch '+eur(FREE-net)+' bis versandkostenfrei';
  }

  var main=r.querySelector('.main'), mimg=main&&main.querySelector('img');
  r.querySelectorAll('.th button').forEach(function(b){
    b.addEventListener('click',function(){
      r.querySelectorAll('.th button').forEach(function(x){x.classList.remove('on')});
      b.classList.add('on');
      if(mimg){mimg.src=b.dataset.full; mimg.alt=b.dataset.alt||mimg.alt;}
      if(main) main.classList.remove('z');
    });
  });
  if(main) main.addEventListener('click',function(){main.classList.toggle('z')});

  var picks=[], bar=r.querySelector('#selbar'), cnt=r.querySelector('#selcount'), sum=r.querySelector('#selsum'), go=r.querySelector('#selgo');
  function refresh(){
    if(!bar) return;
    if(!picks.length){ bar.classList.remove('on'); return; }
    bar.classList.add('on');
    var br=0; picks.forEach(function(p){br+=p.price});
    var d=rate(picks.length), ne=Math.round(br*(100-d)/100), sp=br-ne;
    cnt.textContent=picks.length+(picks.length===1?' Form ausgew\u00E4hlt':' Formen ausgew\u00E4hlt');
    sum.innerHTML = d>0
      ? '<s>'+eur(br)+'</s> \u2192 <em>'+eur(ne)+'</em> \u00B7 \u2212'+d+'\u00A0% \u00B7 '+ship(ne)
      : eur(br)+' \u00B7 '+ship(br)+' \u00B7 ab 3 Formen \u221210\u00A0%';
    go.textContent = d>0 ? 'In den Warenkorb (Sie sparen '+eur(sp)+')' : 'In den Warenkorb';
  }
  r.querySelectorAll('.szg .pick').forEach(function(btn){
    btn.addEventListener('click',function(e){
      e.preventDefault(); e.stopPropagation();
      var id=btn.dataset.pick, card=btn.parentElement;
      var on=card.classList.toggle('sel');
      btn.textContent = on ? '\u2713 Ausgew\u00E4hlt' : '+ Ausw\u00E4hlen';
      if(on) picks.push({id:id,price:parseInt(btn.dataset.price,10)});
      else picks=picks.filter(function(p){return p.id!==id});
      refresh();
    });
  });

  r.querySelectorAll('.q>button').forEach(function(b){
    b.addEventListener('click',function(){
      var q=b.parentElement, a=q.querySelector('.an'), open=q.classList.contains('on');
      r.querySelectorAll('.q').forEach(function(x){x.classList.remove('on');x.querySelector('.an').style.maxHeight=null});
      if(!open){q.classList.add('on'); a.style.maxHeight=a.scrollHeight+'px';}
    });
  });

  var gfb=r.querySelectorAll('[data-gf]');
  gfb.forEach(function(b){
    b.addEventListener('click',function(){
      var id=b.dataset.gf, was=b.classList.contains('on');
      gfb.forEach(function(x){x.classList.remove('on')});
      r.querySelectorAll('.gf .res').forEach(function(x){x.classList.remove('on')});
      if(!was){ b.classList.add('on'); var t=r.querySelector('#'+id); if(t) t.classList.add('on'); }
    });
  });
  if(gfb.length) gfb[0].click();

  var sk=r.querySelector('.sk'), hero=r.querySelector('.hero');
  if(sk&&hero&&'IntersectionObserver' in window){
    new IntersectionObserver(function(e){ sk.style.visibility=e[0].isIntersecting?'hidden':'visible'; },{threshold:0}).observe(hero);
  }

  function add(items,btn){
    btn.disabled=true;
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
    .then(function(x){return x.json()}).then(function(){window.location.href='/cart'})
    .catch(function(){btn.disabled=false;});
  }
  if(go) go.addEventListener('click',function(){
    if(!picks.length) return;
    add(picks.map(function(p){return {id:parseInt(p.id,10),quantity:1}}),go);
  });
  r.querySelectorAll('[data-atc]').forEach(function(b){
    b.addEventListener('click',function(e){e.preventDefault();add([{id:parseInt(b.dataset.atc,10),quantity:1}],b);});
  });
  r.querySelectorAll('[data-set]').forEach(function(b){
    b.addEventListener('click',function(e){
      e.preventDefault();
      var ids=b.dataset.set.split(',').filter(function(x){return x&&x.trim()!==''});
      if(ids.length) add(ids.map(function(i){return {id:parseInt(i,10),quantity:1}}),b);
    });
  });
})();
